<div class="u-wrapper" [ngStyle]="!vm.isInitialized && {'min-height': '200px'}">
	<div class="c-card u-osb-md o-grid__cell--center-h">
		<div class="c-content c-content--lg">
			<div class="o-grid o-grid--center-v">
				<div class="o-grid__cell">
					<div>
						<img id="benuLogo1" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/logo/benu-logo.png" style="max-width: 45%" class="u-hidden@md-and-up">
						<img id="benuLogo2" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/logo/benu-logo.png" style="max-width: 10%" class="u-hidden@up-to-md">
					</div>
					<br/>
					<form name="vm.form" #mainForm="ngForm" (ngSubmit)="vm.submit(mainForm)" *ngIf="!vm.tokenIsExpired" novalidate>
						<h1 class="c-text c-text--heading c-text--s6 c-text--lg">
							{{ vm.headerTextTranslated }}
						</h1>
						<div class="c-modal__content u-no-pt" style="text-align: left!important;" *ngIf="vm.consents">
							<p class="c-text u-ost-xl">{{ 'Benu.Prescription_Purchase_Landing_Page.Checkboxes_Description' | translate }}</p>
							<div class="c-form u-ost-xl">
								<div class="u-ost-md u-osb-lg">
									<div class="c-form__group u-osb-sm" [ngClass]="{'c-form__group--error': vm.submitted && sharing.invalid }">
										<label class="c-checkbox">
											<input type="checkbox" [(ngModel)]="vm.consents.pharmacyDataSharingAccepted" #sharing="ngModel" name="sharing" required>
											<span>{{ 'Pharmacy_Redirect.Consent_Data_Sharing' | translate }}</span>
										</label>
									</div>
									<div class="c-form__group u-osb-sm" [ngClass]="{'c-form__group--error': vm.submitted && processing.invalid }">
										<label class="c-checkbox">
											<input type="checkbox" [(ngModel)]="vm.consents.pharmacyDataProcessingAccepted" #processing="ngModel" name="processing" required>
											<span>{{ 'Pharmacy_Redirect.Consent_Data_Processing' | translate }}</span>
										</label>
									</div>
								</div>
							</div>
						</div>
	
						<br/>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed u-no-p">
							<button id="continueRenewalButton" type="submit" class="c-button c-button--s1 c-button--lg c-button--fit@up-to-sm u-osb-md u-osr-md">
								{{ 'Benu.Prescription_Purchase_Landing_Page.Go_To_Benu_Eshop_Button' | translate }}
							</button>
						</div>
					</form>
					<div *ngIf="vm.tokenIsExpired">
						<h1 class="c-text c-text--heading c-text--lg">
							{{ 'Benu.Prescription_Purchase_Landing_Page.Link_Expired' | translate }}
						</h1>
						<br/>
						<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed u-no-p">
							<button id="goToLoginButton" type="button" (click)="vm.goToLogin()" class="c-button c-button--s1 c-button--lg c-button--fit@up-to-sm u-osb-md u-osr-md">
								{{ 'Benu.Prescription_Purchase_Landing_Page.Login_Forward_Button' | translate }}
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
